import { atom } from "jotai";

export const mobileMenuOpenedState = atom<boolean>(false);
